// ---------------- Requests ----------------

export interface LoginSsoRequestDto {
  code: string;
  origin: string;
  code_verifier: string;
}

export interface LostPasswordRequestDto {
  username: string;
}

export interface RefreshTokenRequestDto {
  refresh_token: string;
  client_security: string;
}

export interface FirstPasswordRequestDto {
  username: string;
  current_password: string;
  password: string;
  password2: string;
}

/** Détail du 403 renvoyé par /auth/login quand le mot de passe temporaire doit être changé. */
export const PASSWORD_CHANGE_REQUIRED = 'PASSWORD_CHANGE_REQUIRED';



// ---------------- Responses ----------------



// ---------------- Shared DTOs ----------------

export interface AdminTicketDto {
  ticket: string;
  expires_in: number;
}

export interface TokenDto {
  access_token: string;
  refresh_token: string;
  token_type: string;
  client_security: string;
  refresh_app: boolean;
}
